(function () {
    'use strict';
    var m = angular.module('gui-v2');
    m.controller('AntiPhishingSettingsController', ["$scope", "modulesDao", "modals", "troubleshooting", function ($scope, modulesDao, modals, troubleshooting) {
        $scope.availableProps = [
            'probability_level',
            'protect_from_impersonation',
            'allow_trust_this_sender_question',
            'allow_impersonation_if_conversed',
            'detect_impersonation_deleted',
            'detect_impersonation_disabled',
            'disable_static_override',
            'domain_age_min_days',
            'enable_first_seen',
            'enable_name_variation',
            'enable_phishtank',
            'enable_punycode',
            'enable_static_link_detection',
            'enable_whois',
            'massive_sender_across_days',
            'massive_sender_last_days',
            'massive_sender_least_mails',
            'massive_sender_least_total_mails',
            'mta_hostname',
            'name_impersonation_action',
            'not_impersonation_domains',
            'phishing_domain_days',
            'scl_whitelist',
            'senior_group',
            'skip_message_without_header',
            'skip_nickname_private_to_bussiness',
            'skip_one_word_name',
            'support_spam_marketing',
            'target_impersonate_domains',
            'use_saas_whitelist',
            'new_domain_action',
            'import_phishing_reports'
        ];
        $scope.model = {};
        var vals = [];
        $scope.foundConfs = [];
        modulesDao.retrieveConfig('ap_avanan').then(function (res) {
            _(res.data).each(function (val, prop) {
                // In case debug is off and it's an only debug param, we don't want to add it
                if (!troubleshooting.entityDebugEnabled() && val.ui_debug_only) {
                    return;
                }
                vals.push({
                    id: prop,
                    order: val.order || 999
                });
                if (_($scope.availableProps).findIndex(function (p) {
                        return p === prop;
                    }) !== -1) {
                    $scope.model[prop] = {
                        type: val.type,
                        label: val.label,
                        tooltip: val.tooltip,
                        buttons: val.buttons,
                        value: val.value,
                        variants: val.variants || []
                    };
                }
            });
            $scope.foundConfs = _.chain(vals).sortBy('order').map(function (item) {
                return item.id;
            }).value();
        });
        $scope.save = function () {
            var body = {};
            _($scope.foundConfs).each(function (prop) {
                if ($scope.model[prop] !== undefined && $scope.model[prop].value !== undefined) {
                    body[prop] = $scope.model[prop].value;
                }
            });
            return modulesDao.saveConfig('ap_avanan', body).then(function () {
                modals.alert('Saved successfully!');
            });
        };
    }]);
}());